import { Component, Input, OnChanges, OnInit, } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { ButtonModule } from '@xref/xref-lib';
import { OrgTrustMarketplaceHelpModalComponent } from './org-trust-marketplace-help-modal/org-trust-marketplace-help-modal.component';

import {TrustApiKeyModalComponent} from "../../../components/trust-api-key-modal/trust-api-key-modal.component";
import {
  TrustApiKeyUpdateModalComponent
} from "../../../components/trust-api-key-modal/trust-api-key-update-modal/trust-api-key-update-modal.component";
import {WarningModalService} from "../../../services/warning-modal/warning-modal.service";
import {AlertBannerService, AlertType} from "../../../lib/alert-banner";
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { HeaderComponent } from 'src/app/components/header/header.component';
import {
  TrustMarketplaceStatusService
} from "../../../services/trust-marketplace-status/trust-marketplace-status.service";
import {ConstantsService} from "../../../services/constants/constants.service";
import {PlanService} from "../../../services/plan-status/plan-status.service";
import * as Cookies from "js-cookie";

@Component({
  selector: 'app-org-trust-marketplace',
  templateUrl: './org-trust-marketplace.component.pug',
  styleUrls: ['./org-trust-marketplace.component.scss'],
  standalone: false
})
export class OrgTrustMarketplaceComponent implements OnInit {
  @Input() org;
  org_detail: any;
  bsModalRef!: BsModalRef
  managePermissions = {};
  roles = ['member', 'member (restricted)', 'billing'];
  apiKeyRoles = ['admin', 'owner', 'support'];
  defaultNotes = false;
  apiKey = '';
  isAccess =false;
  isUpdate = true;
  isPending = false;
  isSupport = false;
  notConnected = true;
  helpModal: BsModalRef;
  connectionFailedText = $localize`Connection failed`;
  connectionFailedTooltip = $localize`Contact <u>support@xref.com</u> or try entering your API key again.`;
  status_code = -1;
  status = '';
  loading = true;
  contactLink = ConstantsService.ACCOUNT_MANAGER_CONTACT
  mergedContactLink = ''
  languageLocal = Cookies.get(ConstantsService.XREF_LOCALE)?.toUpperCase();
  trustUrl:string = environment.TRUST_MARKETPLACE_URL;
  CD_SPRINT_24_01_TRANSLATIONS = false;
  canSetTrustSettings=false
  canSetTrustKey=false
  canUseTrustLink=false
  constructor(
    public modalService: BsModalService,
    private permissions: PermissionsService,
    private confirmModal: WarningModalService,
    private organisationService: OrganisationService,
    private alertList: AlertBannerService,
    private trustMarketplaceStatusService: TrustMarketplaceStatusService,
    private planService: PlanService
  ) {
    this.helpModal = new BsModalRef();
   }

  ngOnInit(): void {
    this.canSetTrustSettings = this.permissions.hasPermission('can_set_trust_settings');
    this.canSetTrustKey = this.permissions.hasPermission('can_set_update_trust_key');
    this.canUseTrustLink = this.permissions.hasPermission('can_use_link_to_trust');

    this.isSupport = this.permissions.userRole === 'support'
    this.getTMPStatus();
  }

  loadTMPStatus()
  {
    let res = this.trustMarketplaceStatusService.getSharedData();
    if(res)
    {
      this.status_code = res?.['status_code'];
      if(res?.['status'])
      {
        this.isAccess = this.canSetTrustSettings

      }
      else{
        this.isAccess = false;
      }
      switch(this.status_code) {
        case 0: {
          this.isUpdate = false;
          break;
        }
        case 1: {
          this.isUpdate = true;
          break;
        }
        case 2: {
          this.isUpdate = true;
          break;
        }
        case 3: {
          this.isUpdate = true;
          break;
        }
      }
    }
  }

  redirectToSupport() {
    this.planService.getSFDCid().subscribe(
      res=>{
        this.mergedContactLink =this.contactLink + res.data.sf_account
        window.open(this.mergedContactLink)
      },
      err=>{
        window.open(this.mergedContactLink)
      }
    )
  }
  showTrustApiKeyModal() {
    const initialState = {
      'apiKey': '',
      'keyExist': false
    }
    let payloadEndpoint = {'marketplace_platform':'trust_marketplace'};
    this.bsModalRef = this.modalService.show(TrustApiKeyModalComponent, Object.assign({}, {
      class: 'modal-dialog-centered modal-api-key',
      initialState
    }));
    this.bsModalRef.content.saveClick.subscribe(res => {
      this.organisationService.postApiKey(payloadEndpoint, res['xrefApiKey']).subscribe(
        res => {
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Trust Marketplace API key has been saved.`,
            keepOnRouteChange: true
          }])
          this.orgGetTMPStatus()
        }, error => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }])
        }
      )
    });
  }
  showTrustApiKeyUpdateModal(apikey?) {
    let payloadEndpoint = {'marketplace_platform':'trust_marketplace'};
    this.organisationService.getApiKey(payloadEndpoint).subscribe(res => {
      if (res['api_key']) {
        this.apiKey = res['api_key'];
      }
      const initialState = {
        'apiKey': apikey || this.apiKey,
        'keyExist': true
      }
      this.bsModalRef = this.modalService.show(TrustApiKeyUpdateModalComponent, Object.assign({}, {
        class: 'modal-dialog-centered l-popup',
        initialState
      }));
      this.bsModalRef.content.saveClick.subscribe(res => {
        this.organisationService.postApiKey(payloadEndpoint, res['xrefApiKey']).subscribe(
          res => {
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! Trust Marketplace API key has been saved.`,
              keepOnRouteChange: true
            }])
            this.orgGetTMPStatus();
          }, error => {
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }])
          }
        )
      });
      this.bsModalRef.content.cancelClick.subscribe(res => {
        const currentApiKey = res;
        this.confirmModal.confirm(
          $localize`Cancel changes?`,
          $localize`All information you have entered will be lost and the existing API key will be retained if you navigate away.` +
          '</span>\n\n' +
          $localize`Do you want to leave this page?`,
          false,
          $localize`Stay on page`, $localize`Leave this page`).subscribe(
          res => {
            if (res) {

            } else {
              this.showTrustApiKeyUpdateModal(currentApiKey);
            }
          }
        )
      });
      this.bsModalRef.content.deleteClick.subscribe(res => this.deleteTMPKey(res));
    })
  }

  deleteTMPKey(res)
  {
    const currentApiKey = res;
      this.confirmModal.confirm(
      $localize`Delete API key?`,
      $localize`\nAre you sure you want to delete this API key?`,
      false,
      $localize`Cancel`,
      $localize`Delete`,
      false,
      true,
      'https://assets.xref.com/omni/shared/error_icon.svg',
      true,
      false,
      true).subscribe(
      res => {
        if (res) {
          let payloadEndpoint = {'marketplace_platform':'trust_marketplace'};
          this.organisationService.deleteApiKey(payloadEndpoint).subscribe(
            res => {
              this.alertList.append([{
                type: AlertType.SUCCESS,
                message: $localize`Success! Trust Marketplace API key has been deleted`,
                keepOnRouteChange: true
              }])
              this.getTMPStatus();
            }, error => {
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true
              }])
            }
          )
        } else {
          this.showTrustApiKeyUpdateModal(currentApiKey);
        }
      }
    )
  }
  showHelp() {

    if(this.isUpdate){

      this.helpModal = this.modalService.show(OrgTrustMarketplaceHelpModalComponent, {
        class: 'modal-dialog-centered xl-popup' , initialState: {isUpdate: true}
      });
    }
    else {
      this.helpModal = this.modalService.show(OrgTrustMarketplaceHelpModalComponent, {
        class: 'modal-dialog-centered xl-popup' ,initialState: {isUpdate: false}
      });
    }

  }

  openTrustMarketPlaceUrl(){
    window.open(this.trustUrl + this.languageLocal);
  }

  public orgGetTMPStatus() {
    this.organisationService.orgTrustMarketPlaceStatus().subscribe(
      res => {
        this.trustMarketplaceStatusService.setSharedData(res);
        this.status_code = res?.status_code;
          this.trustMarketplaceStatusService.updateTrustStatus(res?.status_code);
            this.trustMarketplaceStatusService.updateTrustAdminStatus(res?.tmp_admin_status);

        this.loadTMPStatus();
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }])
      }
    )
  }

  public getTMPStatus() {
    this.organisationService.trustMarketplaceStatus().subscribe(
      res => {
        this.trustMarketplaceStatusService.setSharedData(res);
        this.status_code = res?.status_code;
        this.trustMarketplaceStatusService.updateTrustStatus(res?.status_code);
        this.trustMarketplaceStatusService.updateTrustAdminStatus(res?.tmp_admin_status);

        this.loadTMPStatus();
        this.loading = false
      }, error => {
        this.loading = false
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }])
      }
    )
  }

  public IsAccessScreen(){
    return this.isAccess && this.status_code != -1;
  }

}
